import React, { useEffect, useMemo, useState } from 'react'
import './weather.css';
import CloseIcon from '@mui/icons-material/Close';

function Weather() {
    const [isLoading, setIsLoading] = useState(false);
    const [progress, setProgress] = useState(0);
    const [showResult, setShowResult] = useState(false);
    const [place, setPlace] = useState('');
    const [isInvalidInput, setIsInvalidInput] = useState(false);
    const [isWeatherVisible, setIsWeatherVisible] = useState(false);

    const loadingTexts = useMemo(
      () => [
        'Searching location...',
        'Analyzing the clouds...',
        'Looking outside your window...',
        'Gathering latest info...'
      ],
      []
    );
    const [currentTextIndex, setCurrentTextIndex] = useState(0);
    const [currentText, setCurrentText] = useState(loadingTexts[0]);
  
    useEffect(() => {
      if (isLoading) {
        // Simulating an asynchronous task
        const timer = setInterval(() => {
          setProgress(prevProgress => {
            if (prevProgress >= 100) {
              setIsLoading(false);
              setShowResult(true);
              clearInterval(timer);
              return 0;
            } else {
              return prevProgress + 5;
            }
          });
        }, 500);
  
        return () => clearInterval(timer);
      }
    }, [isLoading]);
  
    useEffect(() => {
      let textTimer;
      if (isLoading && currentTextIndex < loadingTexts.length - 1) {
        textTimer = setTimeout(() => {
          setCurrentTextIndex(prevIndex => prevIndex + 1);
        }, 2500);
      }
    
      return () => clearTimeout(textTimer);
    }, [isLoading, currentTextIndex, loadingTexts.length]);
  
  
  useEffect(() => {
    setCurrentText(loadingTexts[currentTextIndex]);
  }, [currentTextIndex, loadingTexts]);
  
  
    const handleInputChange = (e) => {
      setPlace(e.target.value);
      setIsInvalidInput(false); // Reset the input validation when the input value changes
    };
  
    const handleButtonClick = () => {
      if (place.trim() !== '') {
        setIsLoading(true);
        setProgress(0);
        setCurrentTextIndex(0);
        setIsInvalidInput(false);
      } else {
        setIsInvalidInput(true); // Set the input validation to true if the input is empty
      }
    };
  
    const handleOkClick = () => {
      setShowResult(false);
      setPlace('');
      setCurrentTextIndex(0);
    };

    const handleWeatherPopClick = () => {
        setIsWeatherVisible(prevVisibility => !prevVisibility);
      };
      useEffect(() => {
        if (isWeatherVisible) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'auto';
        }
    }, [isWeatherVisible]);

  
  return (
    <>
    <div className="weather-section">
    <div className="weather-pop-btn" onClick={handleWeatherPopClick}>
      <div className="weather-pop-btn-hov"></div>
        <p className='weather-btn-titl'>Crazy AI weather prediction</p>
    </div>
    {isWeatherVisible &&(
    <div className='weather'>
        {showResult ? (
        <div className="main-div">
          <div className="main-container">
            <div className="main-top">
              <p>AI Weather forecast</p>
              <div className="weather-close" onClick={handleWeatherPopClick}>
                <CloseIcon />
              </div>
            </div>
            <div className="main-bot">
              <p>IDK, just look outside...</p>
              <button onClick={() => { handleOkClick(); handleWeatherPopClick(); }}>Ok</button>
            </div>
          </div>
        </div>
      ) : isLoading ? (
        <div className="main-div">
          <div className="main-container">
            <div className="main-top">
              <p>Fetching weather of {place}</p>
              <div className="weather-close" onClick={handleWeatherPopClick}>
                <CloseIcon />
              </div>
            </div>
            <div className="main-bot">
              <p>{currentText}</p>
              <div className={`loading-bar ${isInvalidInput ? 'input-error' : ''}`}>
                <div className="bar" style={{ width: `${progress}%` }} />
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="main-div">
          <div className="main-container">
            <div className="main-top">
              <p>AI Weather forecast</p>
              <div className="weather-close" onClick={handleWeatherPopClick}>
                <CloseIcon />
              </div>
            </div>
            <div className="main-bot">
              <p>Enter your location:</p>
              <div className="main-input">
              <input
                type="text"
                value={place}
                onChange={handleInputChange}
                className={isInvalidInput ? 'input-error' : ''}
              />
              {isInvalidInput && <p className="input-error-message">Please enter a location</p>}
              </div>
              <button onClick={handleButtonClick}>Check weather</button>
            </div>
          </div>
        </div>
      )}
    </div>
    )}
    </div>
    </>
  )
}

export default Weather